export default __webpack_public_path__ + "static/media/zine-artwork1.aeccf2e7.jpg";